import { TASKS_OVERVIEW } from 'constants/enums'

export const tabs = (canActiveOrganizationSelfSign) => [
  {
    id: 1,
    label: 'Sign-offs',
    intlKey: 'tabs.sign_offs',
    path: `/office-signoffs`,
    counters: [TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF.id],
    visibility: canActiveOrganizationSelfSign ? 'hidden' : null
  },
  {
    id: 2,
    label: 'Sign-offs Locally',
    intlKey: 'tabs.sign_offs_locally',
    path: `/local-office-signoffs`,
    counters: [TASKS_OVERVIEW.AWARD_OFFICE_SIGNOFF_LOCALLY.id]
  }
]

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    sortable: true
  },
  {
    id: 2,
    label: 'First Name',
    sortable: false
  },
  {
    id: 3,
    label: 'Last Name',
    sortable: false
  },
  // {
  //   id: 4,
  //   label: 'Previous Level',
  //   sortable: false
  // },
  {
    id: 5,
    label: 'Current Level',
    sortable: false
  },
  // {
  //   id: 6,
  //   label: 'Award Start Date',
  //   sortable: false
  // },
  {
    id: 7,
    label: 'Award Completion Date',
    sortable: false
  },
  {
    id: 8,
    label: 'Weeks completed/required',
    sortable: false
  }
  // {
  //   id: 9,
  //   label: 'Note from AL',
  //   sortable: false
  // },
  // {
  //   id: 10,
  //   label: 'Action',
  //   sortable: false
  // }
]
